module.exports = __webpack_public_path__ + "img/Create_reward.7f7d435f.png";